import React, { useEffect, useMemo } from 'react';
import {Container, Breadcrumb} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {useTranslation} from "react-i18next";

import ScreenHeader from "../../../components/ScreenHeader/ScreenHeader";
import Notification from "../../../components/Notification/Notification";

import * as actions from '../../../store/actions';

import Styles from './Index.module.scss';

const Index = () => {
    const dispatch = useDispatch();

    const promotions = useSelector(state => state.companies.promotions);

    const notifications = useMemo(() => promotions
        .map(notification => (
            <Notification
                key={`notification-promotion-${notification.id}`}
                className={'flex-grow-1'}
                notification={notification}
            />
        ))
    , [promotions])
    
    useEffect(() => {
        dispatch(actions.getPromotions());
    }, [dispatch]);

    const {t} = useTranslation('common');

    if (!notifications.length) {
        return (
            <div className={Styles.filler}>
                {t('notificationsScreen.noNotifications')}
            </div>
        );
    }

    return (
        <>
            <ScreenHeader>
                <Breadcrumb>
                    <Breadcrumb.Item active data-testid='data-test-notificationsScreen-title'>
                        {t('notificationsScreen.header')}
                    </Breadcrumb.Item>
                    
                    {notifications.length !== 0 && (
                        <span className={Styles.count}>
                            {notifications.length}
                        </span>
                    )}
                </Breadcrumb>
            </ScreenHeader>

            <Container className={Styles.container}>
                {notifications}
            </Container>
        </>
    );
};

export default Index;
